import { SEO } from "@/components/landing/SEO";
import { Nav } from "@/components/landing/Nav";
import { Hero, HeroExtras } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { WhyUs } from "@/components/landing/WhyUs";
import { Equipment } from "@/components/landing/Equipment";
import { WaterBill } from "@/components/landing/WaterBill";
import { Pricing } from "@/components/landing/Pricing";
import { Reviews } from "@/components/landing/Reviews";
import { Booking } from "@/components/landing/Booking";
import { FAQ, faqJsonLd } from "@/components/landing/FAQ";
import { SmartValve } from "@/components/landing/SmartValve";
import { Suburbs } from "@/components/landing/Suburbs";
import { Footer } from "@/components/landing/Footer";
import { MusicToggle } from "@/components/landing/MusicToggle";

export default function LandingPage() {
  return (
    <main>
      <SEO
        title="Leak Detection Perth | $360 Upfront Pricing & Live Availability | The Plumbing & Electrical Co."
        description="Perth's water & gas leak detection specialists. $360 first half-hour (incl. $200 tool fee + GST), live online booking with pick-your-own rock-up time, acoustic & thermal detection, lifetime labour warranty. Call (08) 9477 3848."
        canonical="https://leak-detection.com.au/"
        jsonLd={faqJsonLd}
      />
      <Nav />
      <Hero />
      <Marquee className="hidden lg:block" />
      <WhyUs />
      <Equipment />
      <Pricing />
      <WaterBill />
      <Reviews />
      <Booking />
      <FAQ />
      <SmartValve />
      <Suburbs />
      <Footer />
      <MusicToggle />
    </main>
  );
}
